<template>
  <div>
    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIndex: `/contract/orderlist/own/tobe?id=${this.$route.query.id}`,
      menu: [
        {
          name: "待接单",
          path: `/contract/orderlist/own/tobe?id=${this.$route.query.id}`,
        },
        {
          name: "运送中",
          path: `/contract/orderlist/own/ing?id=${this.$route.query.id}`,
        },
        {
          name: "已送达",
          path: `/contract/orderlist/own/arrive?id=${this.$route.query.id}`,
        },
        {
          name: "待审核",
          path: `/contract/orderlist/own/uncheck?id=${this.$route.query.id}`,
        },
        {
          name: "已完成",
          path: `/contract/orderlist/own/done?id=${this.$route.query.id}`,
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}?id=${this.$route.query.id}`
  },
};
</script>
